import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { ScheduleService } from 'src/app/service/schedule.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-schedule-update',
  templateUrl: './schedule-update.component.html',
  styleUrls: ['./schedule-update.component.scss']
})
export class ScheduleUpdateComponent implements OnInit {

  showLoader: boolean = false;
  updating: boolean = false;
  scheduleHeaderId: any;
  CurrentScheduleHeaderData:any;
  yearId:any;
  semesterId:any;
  gradeId:any;

  updateSchedule = new FormGroup({
    effectiveDateFrom: new FormControl('', [
      Validators.required,
    ]),
    effectiveDateTo: new FormControl('', [
      // Validators.required, 
    ]),
    status: new FormControl('', [
      Validators.required,
    ]),
    active: new FormControl('', [
      Validators.required,
    ]),
  });


  constructor(private scheduleService:ScheduleService,
    private toastrService: ToastrService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService, private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.scheduleHeaderId = params['scheduleId'] || "";
        this.yearId = params['yearId'] || "";
        this.semesterId = params['semesterId'] || "";
        this.gradeId = params['gradeId'] || "";

        if (this.scheduleHeaderId != "") {
          this.getScheduleHeaderById();
          this.showLoader = false;

        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_SCHEDULE'));
          this.router.navigate(['/schedule/schedule']);
        }
      });


  }
  getScheduleHeaderById() {
    this.scheduleService.getScheduleHeaderById(this.scheduleHeaderId).subscribe(
      data => {
        console.log(data);
        this.CurrentScheduleHeaderData = data;
        if(data.effectiveDateFrom)
        {
          data.effectiveDateFrom = this.datePipe.transform(data.effectiveDateFrom, 'yyyy-MM-dd');
        }
        if(data.effectiveDateTo)
        {
          data.effectiveDateTo = this.datePipe.transform(data.effectiveDateTo, 'yyyy-MM-dd');
        }
        this.updateSchedule.controls.effectiveDateFrom.setValue(data.effectiveDateFrom);
        this.updateSchedule.controls.effectiveDateTo.setValue(data.effectiveDateTo);
    this.updateSchedule.controls.status.setValue(data.scheduleStatus);
    this.updateSchedule.controls.active.setValue(data.active);
      },
      error => {
        this.updating = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
      }
    );

  }

  updateScheduleChange() {
    // let classHours = this.updateSchedule.controls.classHours.value;
    // let clinicalHours = this.updateSchedule.controls.clinicalHours.value;
    // this.updateSchedule.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  updateScheduleSubmit() {
    if (this.updateSchedule.valid) {
      console.log("updating schedule setup");
      console.log(this.updateSchedule.value);
      this.updateScheduleHeaderData(this.updateSchedule.controls.effectiveDateFrom.value, this.updateSchedule.controls.effectiveDateTo.value,this.updateSchedule.controls.status.value,this.updateSchedule.controls.active.value );
    } else {
      this.updateSchedule.markAllAsTouched();
      this.updateSchedule.markAsDirty();
    }
  }
  updateScheduleHeaderData(effectiveFrom: string, effectiveTo: string, status: string, active: string) {
    this.updating = true;
    let username = this.globals.currentUserInfo.username;
    let orgId = this.globals.currentUserInfo.orgid;

    this.scheduleService.updateScheduleHeader(username, this.scheduleHeaderId, orgId,this.yearId,this.semesterId,this.gradeId, effectiveFrom, effectiveTo, status, active)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            this.router.navigate(['/schedule/schedule']);
          } else {
            this.updating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
          }
          this.updating = false;
        },
        error => {
          this.updating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_UPDATE'));
        }
      );
  }


  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() {

  }
}




